import { render } from "./LayerBars.vue?vue&type=template&id=2ed4e0cb"
const script = {}

import "./LayerBars.vue?vue&type=style&index=0&id=2ed4e0cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__